// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AppBar2{padding-top:1rem!important}.AppBar2 .AppBar2-sub-title,.AppBar2 .AppBar2-title{color:#a3a3a3;font-family:Open Sans;font-weight:700;margin:0;text-transform:uppercase}.AppBar2 .AppBar2-title{font-size:.75rem}.AppBar2 .AppBar2-sub-title{font-size:9px;font-weight:600}.AppBar2 .children{align-self:flex-end}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
